import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BreadcrumbDefinition } from 'xng-breadcrumb/lib/types';
import { PlanningBoardComponent } from './planning-board.component';

const routes: Routes = [
  {
    path: ':configId',
    component: PlanningBoardComponent,
    data: {
      breadcrumb: {
        label: 'Doc::PlanningConfiguration',
      } as BreadcrumbDefinition,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), PlanningBoardComponent],
})
export class PlanningModule {}
